export interface PreferredTime {
  id: number;
  timeOfDay: string;
  startHour: number;
  endHour: number;
}
